export class ValidateCaptchaRequest {
    captchaResponse: string;    
}